import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => {
  const { theme } = useTheme();

  const switchStyles =
    theme === 'dark'
      ? {
          checked: 'data-[state=checked]:bg-primary',
          unchecked: 'data-[state=unchecked]:bg-slate-700',
          thumb: 'bg-white',
          focus: 'focus-visible:ring-primary',
        }
      : {
          checked: 'data-[state=checked]:bg-primary',
          unchecked: 'data-[state=unchecked]:bg-slate-200',
          thumb: 'bg-white',
          focus: 'focus-visible:ring-primary',
        };

  return (
    <SwitchPrimitives.Root
      className={cn(
        'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        switchStyles.checked,
        switchStyles.unchecked,
        switchStyles.focus,
        theme === 'dark'
          ? 'focus-visible:ring-offset-slate-900'
          : 'focus-visible:ring-offset-white',
        className
      )}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          'pointer-events-none block h-4 w-4 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0',
          switchStyles.thumb
        )}
      />
    </SwitchPrimitives.Root>
  );
});
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
